<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel" aria-hidden="true" style="height: 100vh">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="standard-modalLabel">
          {{ 'attendance.timeline.attendanceTimeline' | translate }}
        </h4>

        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" (click)="close()"></button>
      </div>

      <div class="modal-body scroll">
        <div class="timeline mb-0">
          @if(loading) {
          <loading-component />
          }
          @if(!loading && timelineData().length > 0) {
          <div class="timeline-show text-center">
            <h5 class="m-0 time-show-name">
              {{ 'attendance.timeline.lastUpdate' | translate }}
              {{
              $safeNavigationMigration(timelineData()[0]?.updatedAt)
              | timezoneDate
              : "DD/MM/YYYY - HH:mm"
              : getTimezoneCompanyCurrentUser()
              }}
            </h5>
          </div>
          @for(item of timelineData(); track $index) {
          <div [ngClass]="
                  $index % 2 === 0
                    ? 'timeline-lg-item timeline-item-left'
                    : 'timeline-lg-item timeline-item-right'
                ">
            <div class="timeline-desk">
              <div class="timeline-box">
                <span [ngClass]="$index % 2 === 0 ? 'arrow-alt' : 'arrow'"></span>
                <span class="timeline-icon"><i [class]="item.displayIcon"></i></span>
                <h4 class="mt-0 font-16">{{ item?.displayTitle }}</h4>
                <p class="text-muted">
                  <small>
                    {{
                    $safeNavigationMigration(item?.updatedAt)
                    | timezoneDate
                    : "DD/MM/YYYY - HH:mm"
                    : getTimezoneCompanyCurrentUser()
                    }}
                    -
                    {{ item?.displayStatus }}
                  </small>
                </p>
                <p>{{ item?.displayDescription }}</p>
                @if (item?.user) {
                <small>
                  {{ 'attendance.timeline.registeredBy' | translate }} {{ item?.user?.name }}
                </small>
                }
              </div>
            </div>
          </div>
          }
          }

          @if(!loading && timelineData().length === 0) {
          <div class="timeline-show text-center">
            <h5 class="m-0 time-show-name">
              {{ 'attendance.timeline.noTimelineRecords' | translate }}
            </h5>
          </div>
          }
        </div>
      </div>
      <div class="modal-footer">
      </div>
    </div>
  </div>
</div>